import React from 'react';
import { useTranslation } from 'react-i18next';

import NavigationBar from '../components/NavigationBar';
import MediaList from '../components/MediaList';
import Footer from '../components/Footer/Footer';
import { useResto } from '../contexts/RestoContext';
import Menus from '../components/Menus';

const LegalNotices = () => {
  const { t } = useTranslation();
  const { restoData } = useResto();

  return (
    <div>
      <NavigationBar />
      <h1>{ t('LEGAL_NOTICES')}</h1>
      <div className='p-3'>
        <h2>Informations légales</h2>
        <ul>
          <li>**Propriétaire** : Kubuni</li>
          <li>**Siret** : 818119034</li>
          <li>**RCS** : Toulouse B 818 119 034</li>
          <li>**APE** : 6311Z</li>
        </ul>

        <h2>Société bénéficiaire</h2>
        <ul>
          <li>**Société** : { restoData.company.label }</li>
          <li>**Siret** : { restoData.company.siret }</li>
          <li>**RCS** : { restoData.company.rcs }</li>
          <li>**APE** : { restoData.company.ape }</li>
        </ul>

        <h2>Hébergement</h2>

        <ul>
          <li>**Hébergeur** : OVH</li>
          <li>**Adresse** : 2 rue Kellermann, 59100 Roubaix, France</li>
          <li>**Téléphone** : +33 9 72 10 10 07</li>
          <li>**Email** : <a href="https://www.ovhcloud.com/fr/contact/">Contacter OVH</a></li>
          <li>**Site web** : <a href="https://www.ovhcloud.com/fr/">OVHcloud</a></li>
        </ul>

        <h2>Directeur de la publication</h2>

        <ul>
          <li>**Nom** : { restoData.company.owner.firstname } { restoData.company.owner.lastname }</li>
          <li>**Fonction** : { restoData.company.ownerRole }</li>
        </ul>

        <h2>Propriété intellectuelle</h2>

        <p>Le contenu du site www.{ restoData.website }.{ restoData.extension } est protégé par les droits de propriété intellectuelle du Propriétaire. Toute reproduction, représentation, modification, publication, adaptation de tout ou partie des éléments du site, quel que soit le moyen ou le procédé utilisé, est interdite, sauf autorisation écrite et préalable du Propriétaire.</p>

        <h2>Responsabilité</h2>

        <p>Le Propriétaire ne peut être tenu responsable des dommages directs ou indirects, matériels ou immatériels, causés par l'utilisation du site www.{ restoData.website }.{ restoData.extension }.</p>

        <h2>Liens hypertextes</h2>

        <p>Le site www.{ restoData.website }.{ restoData.extension } peut contenir des liens hypertextes vers d'autres sites web. Le Propriétaire ne peut être tenu responsable du contenu de ces sites web.</p>

        <h2>Collecte de données personnelles</h2>

        <p>Le Propriétaire collecte des données personnelles lors de l'inscription de l'Utilisateur, de la passation d'une commande et de la navigation sur le Site.</p>

        <p>Les données collectées sont les suivantes : nom, prénom, adresse email, adresse postale, numéro de téléphone, données de connexion et de navigation.</p>

        <p>Le Propriétaire s'engage à ne pas transmettre les données collectées à des tiers sans le consentement de l'Utilisateur.</p>

        <p>L'Utilisateur dispose d'un droit d'accès, de rectification, de suppression et d'opposition aux données le concernant.</p>

        <h2>Cookies</h2>

        <p>Le Site utilise des cookies pour améliorer l'expérience utilisateur et à des fins de statistiques.</p>

        <p>L'Utilisateur peut accepter ou refuser l'utilisation des cookies.</p>

        <p>L'Utilisateur peut paramétrer son navigateur pour refuser l'installation de cookies.</p>

        <h2>Loi applicable et juridiction compétente</h2>

        <p>Les présentes mentions légales sont soumises au droit français. En cas de litige, les tribunaux français seront seuls compétents.</p>

        <h2>Contact</h2>

        <p>Pour toute question ou réclamation, l'Utilisateur peut contacter le Directeur de la publication en utilisant les informations de contact disponibles sur le Site</p>
      </div>
      
      <MediaList mediaKey='LEGAL_NOTICES_BOTTOM' maxItems={1}  isShortLine={true} />
      <Menus />
      <Footer />
    </div>
  );
}

export default LegalNotices;